<template>
<section>
    <div class="modal animated fadeIn show oppay" data-backdrop="static">
        <div class="modal-dialog modal-dialog-centered ">
            <button name="closeModal" type="button" id="close" ref="close" class="close" data-dismiss="modal" @click.prevent="cancel"></button>
            <div class="row">
                <div class="col-12">
                    <div class="opt-content card">
                        <div ref="warning" class="opt-content-wrapper active pay-pane active p-4">
                            <div class="text-center">
                                <i class="title-icon warning"></i>
                            </div>
                            <h3 class="text-center">Your Session has expired</h3>
                            <p v-if="hasMessage" class="mb-4" v-text="message"></p>
                            <p v-else class="mb-4">This transaction been cancalled.</p>

                            <div class="modal-body">
                                <div class="row m-0">
                                    <div class="col-12 px-0">
                                        <div class="form-group text-center my-4">
                                            <a href="javascript:void(0)" style="font-size : 14px !important; text-decoration:none" class="btn app-bg-color" @click.prevent="continueToMerchant" :style="style">
                                                {{ client_info && client_info.merchant ? client_info.merchant.return_text :  'Back to merchant'}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
/* eslint-disable */
export default {
    name: 'timeout',
    created() {

        try {
            // console.log(this.$store.state)
            // console.log(this.$route);

            /* if (window.raw && JSON.parse(window.raw).status) {
                var res = JSON.parse(window.raw)
                this.client_info = res.data.client_info; */
                this.hasMessage = true;

                this.message = "Session has expired";
                // res.message= "Session has expired";
                // this.appColor = this.client_info.colors.app + " !important" || this.client_info.colors.primary_button + " !important";
            // }

            console.log(this.$store.state.client_info);

            if (this.$store.state.client_info){
                console.log("This is the console information");
                this.client_info = this.$store.state.client_info;
            }
            
            if (typeof this.client_info.colors !== "undefined" || typeof this.client_info.colors === 'object') {

                this.style = {
                    background: this.client_info.colors.primary_button ? this.client_info.colors.primary_button + ' !important' : appColor,
                    color: this.client_info.colors.payment_description ? this.client_info.colors.payment_description + '!important' : ''
                }

                if (this.client_info && this.client_info !== null && this.client_info.colors)
                    this.appColor = this.client_info.colors.app + " !important" || this.client_info.colors.primary_button + " !important";
                else {
                    this.appColor = 'grey'
                }
            }

        } catch (e) {
            console.log(e)
        }

    },
    data() {
        return {
            hasMessage: false,
            message: '',
            appColor: '',
            client_info: {},
            env: false,
            style: {},
            failedFromStart: '',
        }
    },
    methods: {
        cancel() {
            this.closeIframe();
        },
        continueToMerchant() {
            let referrer = this.$store.state.popupReferrer

            if (!window.raw) {
                var response = {
                    status: 'Failed',
                    message: this.message || "Could not locate errors",
                    data: null,
                }
            } else {
                var res = JSON.parse(window.raw)
                res && res.data ? delete res.data.client_info : '';
                res && res.data ? delete res.data.paymentoptions : '';
                res.message= "Session has expired";

                var response = {
                    status: res ? res.status || "Failed" : "Failed",
                    message: this.message || (res && res.data ? res.data.message : 'No message from the server') || "Could not locate errors",
                    data: res && res.data ? res.data || null : null,
                }
            }

            if (this.$store.state.isFailed)
                response.parentTransRef = this.$store.state.parentTransRef

            if (window.failedFromStart == 'false') {
                response.reference = this.$store.state.transRef || null;
                response.optionsTransRef = this.$store.state.options.optionsTransRef || null;
                response.paymentmethod = this.$store.state.paymentMethod || null;
            }

            this.$store.replaceState({
                paymentMethod: '',
                paymentMethodIndex: '',
                popupReferrer: '',
                payload: {},
                options: {},
                api_key: null,
                hasPaid: false,
                hasOtp: false,
                isFailed: false,
                isLoading: true,
                channels: {},
                parentTransRef: '',
                transRef: '',
                card_cc: '',
                card_exp: '',
                card_cvv: '',
                cardDetails: {
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    card_pin: ''
                }
            });


            // if (this.$route.name !== 'popup-v2')
            this.$router.push('/v2/popup').catch(err => {});

            response.status = "Failed";
            this.client_info = null;
            window.parent.postMessage(JSON.stringify(response), referrer.includes("file://") ? "*" : referrer);
        },
        closeIframe() {
            this.$store.replaceState({
                paymentMethod: 'CARD',
                payload: {},
                options: {},
                api_key: null,
                hasPaid: false,
                isFailed: false,
                hasOtp: false,
                isLoading: true,
                channels: {},
                parentTransRef: '',
                transRef: '',
                card_cc: '',
                card_exp: '',
                card_cvv: '',
                cardDetails: {
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    card_pin: ''
                }
            });

            // if (this.$route.name !== 'popup-v2')
                this.$router.push('/v2/popup').catch(err => {});

            if (isIframe)
                window.parent.postMessage('close', '*');
            else
                console.log("Can only close in an iframe");

        }
    }
};
</script>

<style scoped>
.modal.oppay button.close {
    right: -50px;
}

.text-tiny{
    font-size: 14px;
}
</style>
